module.exports = __webpack_public_path__ + "img/jxsy2.e2cdabfd.jpg";